// Module-level router singleton. Kept separate from '@/router' so consumers
// shipped in the main bundle (e.g. AppLink) don't pull vue-router and the
// route registry in — those load only with mountRouterApp.
//
// Why not useRouter()? It reads an app-level injection, so it only works
// inside apps created with app.use(router) — on every non-router page it
// returns undefined and logs an inject warning per component instance. This
// probe is injection-free and safe to call from globally registered
// components on any page.
let router = null

// Name of the catch-all route matching every path no opted-in feature claims.
// It exists so router.resolve() can classify arbitrary hrefs without dev
// warnings; navigating to it means a full page load (see router guards).
export const FALLBACK_ROUTE = 'full-page-load'

export function setRouter(r) {
  router = r
}

// Returns null on pages that mounted without the router shell.
export function getRouter() {
  return router
}
